import React, { useState } from "react";
import { Box, Typography, IconButton, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CloudOff, InfoOutlined } from "@mui/icons-material";
import AmSatelliteMapOverlay from "./AmSatelliteMapOverlay";
import CustomTooltip from "../Custom/CustomTooltip";
import PropTypes from "prop-types";

const AmSatelliteImagery = ({ image_data, polygon }) => {
  const { tile, dt, cl } = image_data || {}; // { tile, dt, dc, cl }
  const { t } = useTranslation();

  const [showCloudInfo, setShowCloudInfo] = useState(false);
  // const [showDataInfo, setShowDataInfo] = useState(false);

  const isValidData = tile && polygon;
  const hasCloudCoverage = cl > 80; // Consider high cloud coverage as problematic

  return (
    <div>
      {isValidData ? (
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: 3,
            }}
          >
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              {t("Satellite Map View")}
            </Typography>
          </Box>

          <Box>
            <AmSatelliteMapOverlay tile={tile} polygon={polygon} />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mt: 2,
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary">
                {t("Last updated")}: {new Date(dt * 1000).toLocaleDateString()}{" "}
                {new Date(dt * 1000).toLocaleTimeString()}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 1,
                  paddingTop: 1,
                }}
              >
                <Typography>
                  {t("Cloud Cover")}:
                  <span
                    style={{
                      color: cl > 50 ? "#d32f2f" : "#2e7d32",
                      marginLeft: 4,
                    }}
                  >
                    {cl}%
                  </span>
                  <CustomTooltip
                    open={showCloudInfo}
                    onClose={() => setShowCloudInfo(false)}
                    title={
                      <>
                        <strong>
                          {t("Approximate percent of cloud coverage")}
                        </strong>
                        <br />
                        {cl > 50
                          ? t("High cloud coverage may affect image quality")
                          : t("Good visibility")}
                      </>
                    }
                  >
                    <IconButton
                      size="small"
                      sx={{ p: 0, ml: 0.5 }}
                      onClick={() => setShowCloudInfo(!showCloudInfo)}
                      onMouseEnter={() => setShowCloudInfo(true)}
                      onMouseLeave={() => setShowCloudInfo(false)}
                    >
                      <InfoOutlined fontSize="small" color="action" />
                    </IconButton>
                  </CustomTooltip>
                </Typography>

                {/* <Typography>
                  {t("Data Coverage")}:
                  <span
                    style={{
                      color: dc < 50 ? "#d32f2f" : "#2e7d32",
                      marginLeft: 4,
                    }}
                  >
                    {dc}%
                  </span>
                  <CustomTooltip
                    open={showDataInfo}
                    onClose={() => setShowDataInfo(false)}
                    title={
                      <>
                        <strong>
                          {t("Approximate percent of valid data coverage")}
                        </strong>
                        <br />
                        {dc < 50
                          ? t("Limited data coverage")
                          : t("Good data coverage")}
                      </>
                    }
                  >
                    <IconButton
                      size="small"
                      sx={{ p: 0, ml: 0.5 }}
                      onClick={() => setShowDataInfo(!showDataInfo)}
                      onMouseEnter={() => setShowDataInfo(true)}
                      onMouseLeave={() => setShowDataInfo(false)}
                    >
                      <InfoOutlined fontSize="small" color="action" />
                    </IconButton>
                  </CustomTooltip>
                </Typography> */}
              </Box>
            </Box>
          </Box>

          {hasCloudCoverage && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              {t(
                "High cloud coverage detected. Some areas may not be clearly visible."
              )}
            </Alert>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            p: 3,
            my: 2,
            border: "1px solid #f5c6cb",
            borderRadius: 2,
            bgcolor: "#f8d7da",
            display: "flex",
            alignItems: "center",
          }}
          role="alert"
        >
          <CloudOff sx={{ color: "#721c24", mr: 2, fontSize: 28 }} />
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              variant="h6"
              sx={{ color: "#721c24", fontWeight: "bold", mb: 0.5 }}
            >
              {t("Satellite Imagery Unavailable")}
            </Typography>
            <Typography variant="body2" sx={{ color: "#721c24" }}>
              {t(
                "Satellite imagery is not available as it is cloudy in your area"
              )}
            </Typography>
          </Box>
        </Box>
      )}
    </div>
  );
};

AmSatelliteImagery.propTypes = {
  image_data: PropTypes.shape({
    tile: PropTypes.string,
    dt: PropTypes.number,
    dc: PropTypes.number,
    cl: PropTypes.number,
  }),
  polygon: PropTypes.array,
};

export default AmSatelliteImagery;
